// extracted by mini-css-extract-plugin
module.exports = {"referenceList":"ReferenceList_referenceList__EYFBb"};